const initialState = {
  addCampaignOpen: false,
  addEditAgencyInfoOpen: false,
  addTranslationOpen: false,
  addUserOpen: false,
  agency: {},
  threeWayCallDetails: false,
  deleteCampaignOpen: false,
  deleteTranslationOpen: false,
  editInfoOpen: false,
  editLogoMode: '',
  editSiteOpen: false,
  patternsModal: false,
  historyOpen: false,
  pageSpecificTab: 'entry_page',
  addUserPage: 'info',
  resultsHistoryOpen: false,
  sidebarOpen: false,
  siteConfig: 'site_wide',
  siteWideTab: 'drugs_and_dosages',
  tab: 'details',
  userSidebarOpen: false,
  staleClientModal: false,
  selectedLeadsModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EDIT_LOGO_MODE':
      return { ...state, editLogoMode: action.payload };
    case 'OPEN_EDIT_SITE':
      return { ...state, editSiteOpen: true };
    case 'CHANGE_SITE_CONFIG':
      return { ...state, siteConfig: action.config };
    case 'CHANGE_SITE_WIDE_TAB':
      return { ...state, siteWideTab: action.tab };
    case 'CHANGE_PAGE_SPECIFIC_TAB':
      return { ...state, pageSpecificTab: action.tab };
    case 'OPEN_ADD_USER':
      return { ...state, addUserOpen: true };
    case 'OPEN_ADD_AGENCY':
      return { ...state, addEditAgencyInfoOpen: true };
    case 'OPEN_DELETE_CAMPAIGN':
      return { ...state, deleteCampaignOpen: true };
    case 'OPEN_ADD_CAMPAIGN':
      return { ...state, addCampaignOpen: true };
    case 'OPEN_EDIT_INFO':
      return {
        ...state,
        editInfoOpen: true,
        tab: 'details',
      };
    case 'OPEN_BATCH_HISTORY':
      return { ...state, historyOpen: true };
    case 'OPEN_RESULTS_HISTORY':
      return { ...state, resultsHistoryOpen: true };
    case 'CHANGE_TAB':
      return { ...state, tab: action.tab };
    case 'CHANGE_ADD_USER_PAGE':
      return { ...state, addUserPage: action.page };
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarOpen: !state.sidebarOpen };
    case 'TOGGLE_USER_SIDEBAR':
      return {
        ...state,
        userSidebarOpen: action.payload ? action.payload : !state.userSidebarOpen,
      };
    case 'SET_ADD_TRANSLATION_MODAL':
      return { ...state, addTranslationOpen: action.payload };
    case 'SET_DELETE_TRANSLATION_MODAL':
      return { ...state, deleteTranslationOpen: action.payload };
    case 'CLOSE_MODAL':
      return { ...state, [action.modal]: false };
    case 'OPEN_MODAL':
      return { ...state, [action.modal]: true };
    case 'SET_MODAL':
      return { ...state, ...action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
